import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';
import { AuthGuard, FeatureGuard } from '@ta/user';

export enum EInvitationsRoute {
  invitations = 'invitations',
  list = 'list',
}

TaRoutes.addRoute({
  key: EInvitationsRoute.invitations,
  url: 'invitations',
  children: [
    {
      key: EInvitationsRoute.list,
      url: 'list',
    },
  ],
});

export const invitationsRoutes: Routes = [
  {
    path: TaRoutes.getUrl([EInvitationsRoute.invitations, EInvitationsRoute.list]),
    title: 'app.pages.invitations.title',
    loadComponent: () =>
      import('./pages/invitations-list/invitations-list').then((c) => c.InvitationsListPage),
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: 'invitations', level: 'authorize' },
  },
];
